import React, { useState } from 'react';
import PropTypes from 'prop-types';

const dash = (value) => value || 'No registrado';

const PatientPanel = ({ patient }) => {
  const [verMas, setVerMas] = useState(false);

  if (!patient) return null;

  const calcularEdad = (dob) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Tipo de visita: se infiere de si ya existen consultas previas, no del
  // estado civil (el chip original leia civil_status, lo que mostraba el
  // dato equivocado en pantalla).
  const tipoVisita = patient.consultas?.length ? 'Control' : 'Primera vez';

  return (
    <section className="zf-patient-panel">
      <span className="zf-patient-panel__label">PACIENTE EN ATENCIÓN</span>
      <h3>{patient.firstname} {patient.lastname}</h3>
      <div className="zf-patient-panel__chip-row">
        <span className="zf-patient-panel__chip">{calcularEdad(patient.dob)} años</span>
        <span className="zf-patient-panel__chip">{tipoVisita}</span>
      </div>

      {/* Esencial para documentacion en papel - siempre visible, sin clics */}
      <div className="zf-patient-panel__data">
        <p><strong>RUT:</strong> {patient.dni}</p>
        <p><strong>Dirección:</strong> {dash(patient.address)}</p>
        <p><strong>Ciudad:</strong> {dash(patient.ciudad)}</p>
      </div>

      <button
        type="button"
        className={`zf-patient-panel__vermas ${verMas ? 'open' : ''}`}
        onClick={() => setVerMas((v) => !v)}
      >
        Ver más <span className="zf-patient-panel__vermas-arrow">▾</span>
      </button>

      {verMas && (
        <div className="zf-patient-panel__extra">
          <p><strong>Fecha nacimiento:</strong> {dash(patient.dobFormatted)}</p>
          <p><strong>Teléfono:</strong> {dash(patient.phone)}</p>
          <p><strong>Comuna:</strong> {dash(patient.comuna)}</p>
          <p><strong>Estado civil:</strong> {dash(patient.civil_status)}</p>
          <p><strong>Nivel escolar:</strong> {dash(patient.level_school)}</p>
          <p><strong>Ocupación:</strong> {dash(patient.occupation)}</p>
          <p><strong>Religión:</strong> {dash(patient.religion)}</p>
          <p><strong>Previsión:</strong> {dash(patient.prevision)}</p>
          <p><strong>Email:</strong> {dash(patient.email)}</p>
          <p><strong>Último control:</strong> {dash(patient.lastControl)}</p>
        </div>
      )}
    </section>
  );
};

PatientPanel.propTypes = {
  patient: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    dob: PropTypes.string,
    dobFormatted: PropTypes.string,
    dni: PropTypes.string,
    address: PropTypes.string,
    ciudad: PropTypes.string,
    comuna: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    civil_status: PropTypes.string,
    level_school: PropTypes.string,
    occupation: PropTypes.string,
    religion: PropTypes.string,
    prevision: PropTypes.string,
    lastControl: PropTypes.string,
    consultas: PropTypes.array,
  }),
};

export default PatientPanel;
